import React from 'react';

import {
  DateTime,
} from 'luxon';

import {
  coreUtils,
} from '@gymcloud/core';

import {
  Flex,
  SVG,
} from 'web-styled';

import * as S from './styled';

const isFloat = (n) => Number(n) === n && n % 1 !== 0;
const getAmound = (invoice) => {
  const amount = invoice.total / 100;
  return (isFloat(amount)
    ? amount.toFixed(2)
    : amount);
};

type Props = {
  invoices: any[]
};

const InvoiceList = ({ invoices }: Props) => (
  <Flex
    fillSpace
    column
    align="center"
    padding="0 15px"
  >
    <S.TableHeader>
      <S.TableCell>
        Date
      </S.TableCell>
      <S.TableCell>
        Description
      </S.TableCell>
      <S.TableCell justify="center">
        Amount
      </S.TableCell>
      <S.TableCell justify="center">
        Status
      </S.TableCell>
    </S.TableHeader>
    {invoices.map(invoice => (
      <S.TableRow key={invoice.id}>
        <S.TableCell>
          {DateTime.fromISO(invoice.created).toFormat('dd MMM yyyy')}
        </S.TableCell>
        <S.TableCell>
          {invoice.normalizedDescription}
        </S.TableCell>
        <S.TableCell justify="center">
          {coreUtils.getCurrencySymbol(invoice.currency) || '$'}
          {getAmound(invoice)}
        </S.TableCell>
        <S.TableCell justify="center">
          {invoice.status === 'paid' ? (
            <SVG.CheckIcon size={17} strokeWidth={3} className="success-color" />
          ) : (
            <SVG.X size={17} strokeWidth={3} className="danger-color" />
          )}
        </S.TableCell>
      </S.TableRow>
    ))}
  </Flex>
);

export default InvoiceList;
